import React, { useEffect, useMemo } from 'react';
import { ListDairyInsurancePricesResponse } from '../../../../../../Generated/Raven-Demeter';
import Dropdown from '../../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import { DairyRevenueProtectionCalculationInputs } from '../DairyRevenueProtectionDefinitions';

interface IDairyRevenueProtectionCoverageLevelDropdownProps {
    calculationInputs: DairyRevenueProtectionCalculationInputs;
    setCalculatorInputs: (value: DairyRevenueProtectionCalculationInputs) => void;
    listDairyInsurancePricesResponse: ListDairyInsurancePricesResponse;
}

const DairyRevenueProtectionCoverageLevelDropdown: React.FC<IDairyRevenueProtectionCoverageLevelDropdownProps> = (
    props: IDairyRevenueProtectionCoverageLevelDropdownProps,
) => {
    const [translations] = useLanguage();

    const coverageLevelOptions = useMemo(() => {
        if (!props.listDairyInsurancePricesResponse?.dairyInsuranceSubsidies) {
            return [];
        }

        return props.listDairyInsurancePricesResponse.dairyInsuranceSubsidies.map((x) => ({
            label: `${x.coverageLevelPercent}`,
            value: x.coverageLevelPercent,
        }));
    }, [props.listDairyInsurancePricesResponse]);

    useEffect(() => {
        const currentCoverageLevel = props.calculationInputs.coverageLevelPercent;
        const coverageLevelIsValid = currentCoverageLevel && coverageLevelOptions.map((x) => x.value).includes(currentCoverageLevel);
        if (coverageLevelOptions.length === 0 || coverageLevelIsValid) {
            return;
        }

        props.setCalculatorInputs({ ...props.calculationInputs, coverageLevelPercent: coverageLevelOptions[0].value });
    }, [coverageLevelOptions]);

    return (
        <Dropdown
            value={props.calculationInputs.coverageLevelPercent}
            options={coverageLevelOptions}
            handleOptionChange={(value) => props.setCalculatorInputs({ ...props.calculationInputs, coverageLevelPercent: value })}
            label={translations.risk.margin.fields.coverageLevel}
            track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'DairyCoverageLevelChanged' }}
        />
    );
};

export default DairyRevenueProtectionCoverageLevelDropdown;
